export default __webpack_public_path__ + "static/media/imcosun-rev.30e7d429.svg";